<template>
    <v-row no-gutters align="center" :class="['calendar-header-day mx-0', {'line-bottom': isCurrentMonth}]">
        <v-col cols="3" @click="$emit('click:day')" class="calendar-day">
            {{ day }}
        </v-col>
        <v-col cols="9" class="text-right pr-1" v-if="isCurrentMonth">
            <v-row no-gutters>
                <v-col cols="6">
                    <v-tooltip left :color="hasNote ? '#333333' : 'transparent'">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                fab x-small depressed text
                                v-bind="attrs" v-on="on"
                                @click="$emit('click:note')"
                                :color="hasNote ? 'secondary' : 'null'"
                            >
                                <v-icon size="21">{{ hasNote ? 'mdi-note-edit' : 'mdi-note-plus' }}</v-icon>
                            </v-btn>
                        </template>
                        <span v-html="formatNote()"/>
                    </v-tooltip>
                </v-col>
                <v-col cols="6">
                    <button-tooltip
                        v-if="!hasEventsToday"
                        @click="$emit('click:add')"
                        fab text color="#99CC00" x-small
                        :tooltip="$t('tooltips.add_exercise')"
                    >
                        <v-icon size="21">$add_circle</v-icon>
                    </button-tooltip>
                    <v-menu v-else bottom left offset-y open-on-hover content-class="kimsa-elevation">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" small color="#078571">
                                <v-icon size="17">$dots_vertical</v-icon>
                            </v-btn>
                        </template>

                        <v-list dense>
                            <v-list-item
                                v-for="(menu, i) in menuOptions" :key="i"
                                @click="$emit(`click:${menu.value}`)"
                                :class="[{'menu-list': i !== menuOptions.length - 1}]"
                            >
                                <v-list-item-title>
                                    <v-row align="center">
                                        <v-col cols="12">
                                            <v-icon size="17" color="#03342C">{{ menu.icon }}</v-icon>
                                            <span class="menu-list-text">
                                        {{ menu.title }}
                                    </span>
                                        </v-col>
                                    </v-row>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";

export default {
    name: "DayLabelCalendar",
    components: {ButtonTooltip},
    props: {
        day: {
            type: [Number, String],
            default: 0
        },
        isCurrentMonth: {
            type: Boolean,
            default: false
        },
        hasEventsToday: {
            type: Boolean,
            default: false
        },
        canLockDay: {
            type: Boolean,
            default: false
        },
        note: {
            type: Object,
            default: null
        }
    },
    computed: {
        menuOptions(vm = this) {
            if(vm.canLockDay) {
                return [
                    {title: vm.$t('calendar.copy_routine'), icon: '$copy', value: 'copy'},
                    {title: vm.$t('calendar.copy_week'), icon: '$copy', value: 'copy:week'},
                    // {title: vm.$t('calendar.lock_day'), icon: '$lock', value: 'lock'},
                    {title: vm.$t('calendar.save_program'), icon: '$save', value: 'save:program'},
                    {title: vm.$t('calendar.save_routine'), icon: '$save', value: 'save:routine'},
                    {title: vm.$t('calendar.delete_routine'), icon: '$delete', value: 'delete'},
                ]
            }
            return [
                {title: vm.$t('calendar.copy_routine'), icon: '$copy', value: 'copy'},
                {title: vm.$t('calendar.copy_week'), icon: '$copy', value: 'copy:week'},
                {title: vm.$t('calendar.save_program'), icon: '$save', value: 'save:program'},
                {title: vm.$t('calendar.save_routine'), icon: '$save', value: 'save:routine'},
                {title: vm.$t('calendar.delete_routine'), icon: '$delete', value: 'delete'},
            ]
        },
        hasNote(vm = this) {
            return !!vm.note?.message
        }
    },
    methods: {
        formatNote() {
            const vm = this
            let message = vm.note?.message || ''
            return message.replace(/\n/g, '<br>');
        }
    }
}
</script>

<style scoped>

.calendar-header-day {
    height: 60px;
    margin-bottom: 4px;
}

.line-bottom:after {
    content: '';
    border-bottom: 1px solid #D9D9D9;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
}

.calendar-day {
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #333333;
}

.calendar-day:hover {
    color: #99CC00;
}

.menu-list:after {
    content: '';
    position: absolute;
    border-bottom: 1px solid #D9D9D9;
    width: 85%;
}

.menu-list-text {
    color: #03342C;
    font-weight: 300;
    font-size: 13px;
    line-height: 12px;
}

</style>